import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { useState } from 'react';
import RowsItem from './RowsItem';

type RowsChildType = {
  imageGadget: any;
};

const RowsChild: React.FC<RowsChildType> = (props) => {
  const [checkbox, setCheckbox] = useState(
    new Array(
      props.imageGadget[1].length
    ).fill(false)
  );
  const [checkboxParent, setCheckboxParent] = useState(false);

  const handleParentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxParent(event.target.checked);
    setCheckbox(
      new Array(props.imageGadget[1].length).fill(event.target.checked)
    );
  };

  const handleSetCheckboxParent = (value: boolean) => {
    setCheckboxParent(value);
  };

  const handleSetCheckbox = (value: boolean[]) => {
    setCheckbox(value);
  };

  return (
    <Accordion
      sx={{
        boxShadow: 'none',
        // '&.MuiPaper-root.MuiAccordion-root': { mx: '-24px' },
        '&.MuiPaper-root.MuiAccordion-root.Mui-expanded': { my: 0 },
        '&.MuiPaper-root.MuiAccordion-root::before': {
          backgroundColor: '#F3F3F3',
        },
      }}
    >
      <AccordionSummary
        sx={{
          my: '0px',
          '& .MuiAccordionSummary-content': { my: '7px' },
        }}
        expandIcon={
          <Box
            component={'img'}
            src='/images/icons/ic-arrow-down.svg'
            alt='arrow down'
          />
        }
        aria-controls='panel1-content'
        id='panel1-header'
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={checkboxParent}
              onChange={(e) => handleParentChange(e)}
            />
          }
          label={props.imageGadget[0] ? props.imageGadget[0] : ''}
          sx={{
            '&.MuiFormControlLabel-root .MuiFormControlLabel-label': {
              pl: '40px',
              ml: '-40px',
              zIndex: 10,
            },
          }}
        />
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={'24px'}>
          {props.imageGadget[1] &&
            props.imageGadget[1]
              .map((img: any, index: number) => {
                return (
                  <RowsItem
                    key={index}
                    index={index}
                    img={img}
                    checkbox={checkbox}
                    handleSetCheckbox={handleSetCheckbox}
                    handleSetCheckboxParent={handleSetCheckboxParent}
                    imageList={props.imageGadget[1]}
                  />
                );
              })}
          <Grid item width={'107px'}>
            <Stack
              justifyContent={'center'}
              alignItems={'center'}
              height={'100%'}
            >
              <Box
                component={'img'}
                src='/images/icons/ic-plus.svg'
                alt='ic-plus'
                width={'24px'}
                height={'24px'}
              />
            </Stack>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default RowsChild;
